import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, Form } from 'reactstrap';
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';

//import images
import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import LightDark from '../Components/Common/LightDark';

import { changeSidebarVisibility } from '../slices/thunks';
import LeaveNotifications from 'Components/Common/leavenotification';

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }: any) => {
    const dispatch: any = useDispatch();

    // Selectors for layout and company data
    const selectDashboardData = createSelector(
        (state: { Layout: any; }) => state.Layout,
        (sidebarVisibilitytype) => sidebarVisibilitytype.sidebarVisibilitytype
    );

    const selectCompanyData = createSelector(
        (state: { Company: any; }) => state.Company,
        (company) => ({
            companyData: company?.data || null,
            companyLoading: company?.loading || false,
            companyError: company?.error || null,
        })
    );

    const sidebarVisibilitytype = useSelector(selectDashboardData);
    const { companyData, companyLoading, companyError } = useSelector(selectCompanyData);

    const [search, setSearch] = useState<boolean>(false);
    const [logoError, setLogoError] = useState<boolean>(false);
    const [logoLoaded, setLogoLoaded] = useState<boolean>(false);

    // Reset states when company data changes
    useEffect(() => {
        setLogoError(false);
        setLogoLoaded(false);
    }, [companyData]);

    const toogleSearch = () => {
        setSearch(!search);
    };

    const toogleMenuBtn = () => {
        var windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        dispatch(changeSidebarVisibility("show"));

        if (windowSize > 767)
            humberIcon.classList.toggle('open');

        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }

        //For collapse vertical and semibox menu
        if (sidebarVisibilitytype === "show" && (document.documentElement.getAttribute('data-layout') === "vertical" || document.documentElement.getAttribute('data-layout') === "semibox")) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'sm') ? document.documentElement.setAttribute('data-sidebar-size', '') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'lg') ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }

        //Two column menu
        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
        }
    };

    // Check if we should show logo
    const shouldShowLogo = companyData?.logo && !logoError && logoLoaded;

    // Get company name for alt text
    const getCompanyName = () => {
        return companyData?.name || 'Company';
    };

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box horizontal-logo">
                                {/* Dark theme logo - only shows if API logo exists */}
                                <Link to="/" className="logo logo-dark">
                                    {shouldShowLogo ? (
                                        <>
                                            <span className="logo-sm">
                                                <img
                                                    src={companyData.logo}
                                                    alt={getCompanyName()}
                                                    height="22"
                                                    onError={() => setLogoError(true)}
                                                    onLoad={() => setLogoLoaded(true)}
                                                    crossOrigin="anonymous"
                                                />
                                            </span>
                                            <span className="logo-lg">
                                                <img
                                                    src={companyData.logo}
                                                    alt={getCompanyName()}
                                                    height="17"
                                                    onError={() => setLogoError(true)}
                                                    onLoad={() => setLogoLoaded(true)}
                                                    crossOrigin="anonymous"
                                                />
                                            </span>
                                        </>
                                    ) : (
                                        // Show nothing when no logo - empty spans maintain layout
                                        <>
                                            <span className="logo-sm" style={{ height: '22px', display: 'inline-block' }}></span>
                                            <span className="logo-lg" style={{ height: '17px', display: 'inline-block' }}></span>
                                        </>
                                    )}
                                </Link>

                                {/* Light theme logo - only shows if API logo exists */}
                                <Link to="/" className="logo logo-light">
                                    {shouldShowLogo ? (
                                        <>
                                            <span className="logo-sm">
                                                <img
                                                    src={companyData.logo}
                                                    alt={getCompanyName()}
                                                    height="22"
                                                    onError={() => setLogoError(true)}
                                                    onLoad={() => setLogoLoaded(true)}
                                                    crossOrigin="anonymous"
                                                />
                                            </span>
                                            <span className="logo-lg">
                                                <img
                                                    src={companyData.logo}
                                                    alt={getCompanyName()}
                                                    height="17"
                                                    onError={() => setLogoError(true)}
                                                    onLoad={() => setLogoLoaded(true)}
                                                    crossOrigin="anonymous"
                                                />
                                            </span>
                                        </>
                                    ) : (
                                        // Show nothing when no logo - empty spans maintain layout
                                        <>
                                            <span className="logo-sm" style={{ height: '22px', display: 'inline-block' }}></span>
                                            <span className="logo-lg" style={{ height: '17px', display: 'inline-block' }}></span>
                                        </>
                                    )}
                                </Link>

                                {/* Optional minimal indicators - remove if not wanted */}
                                {process.env.NODE_ENV === 'development' && (
                                    <>
                                        {companyLoading && !companyData && (
                                            <span className="badge bg-info ms-2" style={{ fontSize: '10px' }}>
                                                Loading...
                                            </span>
                                        )}

                                        {(!companyData || !companyData.logo || logoError) && !companyLoading && (
                                            <span className="badge bg-secondary ms-2" style={{ fontSize: '10px', opacity: 0.6 }}>
                                                No logo
                                            </span>
                                        )}
                                    </>
                                )}
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                        </div>

                        <div className="d-flex align-items-center">

                            <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                                    <i className="bx bx-search fs-22"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                    <Form className="p-3">
                                        <div className="form-group m-0">
                                            <div className="input-group">
                                                <input type="text" className="form-control" placeholder="Search ..."
                                                    aria-label="Recipient's username" />
                                                <button className="btn btn-primary" type="submit"><i
                                                    className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                </DropdownMenu>
                            </Dropdown>

                            {/* FullScreenDropdown */}
                            <FullScreenDropdown />
                            <LeaveNotifications />
                            {/* Dark/Light Mode set */}
                            <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            />

                            {/* ProfileDropdown */}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;